import React, { useState } from "react";
import { Link } from "react-router";
import { NewButton } from "./NewButton";
import { Celebration } from "./calendar/ordinariate-calendar";
import { PRAY_PATH, RUBRIC_COLOR } from "./tokens";

const getFeriaTitle = (month: number, date: number) => {
    if (month === 12) {
        if (date === 17) return "O Sapientia";
        if (date === 18) return "O Adonai";
        if (date === 19) return "O Radix Jesse";
        if (date === 20) return "O Clavis David";
        if (date === 21) return "O Oriens";
        if (date === 22) return "O Rex Gentium";
        if (date === 23) return "O Emmanuel";
    }

    return "Feria";
};

export const NewCelebrationList: React.FC<{
    year: number;
    month: number;
    date: number;
    options: Celebration[];
    outranked: Celebration[];
    firstEvensongList: string[];
    isEvening: boolean;
    isToday: boolean;
    compact: boolean;
    votivesNotAllowedReason: string | undefined;
}> = (props) => {
    const {
        year,
        month,
        date,
        options,
        outranked,
        firstEvensongList,
        isEvening,
        isToday,
        compact,
    } = props;

    const [showOther, setShowOther] = useState(false);

    return (
        <div style={{ lineHeight: compact ? 1.2 : undefined }}>
            {options
                .filter((celebration) => !celebration.label.includes("votive-"))
                .sort((a, b) => {
                    if (a.optional) {
                        return 1;
                    }

                    if (b.optional) {
                        return -1;
                    }

                    return a.rank - b.rank;
                })
                .map((celebration, celebrationIndex) => {
                    let liturgicalColor = "#4d9c2c"; // green
                    if (
                        celebration.title.includes("Advent") ||
                        celebration.title.includes("Lent") ||
                        celebration.title.includes("Palm Sunday") ||
                        celebration.title.includes("gesima") ||
                        celebration.title.includes("Passion") ||
                        celebration.title === "Holy Saturday" ||
                        celebration.title === "Maundy Thursday" ||
                        celebration.title.includes("Ash Wednesday") ||
                        celebration.title === "ANZAC Day" ||
                        celebration.title.includes("Ember") ||
                        celebration.title.includes("December")
                    ) {
                        liturgicalColor = "#6f3eb0"; // purple
                    }
                    if (
                        celebration.type === "memorial" ||
                        celebration.title.includes("Easter") ||
                        celebration.title.includes("Christmas") ||
                        celebration.title === "Rogation Monday" ||
                        celebration.title === "Rogation Tuesday" ||
                        celebration.title === "Rogation Wednesday" ||
                        celebration.title === "Rogation Thursday" ||
                        celebration.title === "Rogation Friday" ||
                        celebration.title === "Rogation Saturday" ||
                        celebration.title.includes("Ascension")
                    ) {
                        liturgicalColor = "#ffffff"; // white
                    }
                    if (
                        celebration.type === "feast" ||
                        celebration.type === "solemnity"
                    ) {
                        liturgicalColor = "#fdde6c"; // gold
                    }
                    if (
                        celebration.subtitle
                            ?.toLocaleLowerCase()
                            .includes("martyr") ||
                        celebration.title
                            .toLocaleLowerCase()
                            .includes("martyr") ||
                        celebration.subtitle?.includes("Apostle") ||
                        celebration.subtitle?.includes("Evangelist") ||
                        celebration.title.includes("Whit") ||
                        celebration.title.includes("Pentecost") ||
                        celebration.title.includes("Holy Cross")
                    ) {
                        liturgicalColor = "#c23b1d"; // red
                    }
                    if (celebration.title.includes("Holy Week")) {
                        liturgicalColor = "#6f3eb0"; // purple
                    }
                    if (
                        celebration.title === "All Souls" ||
                        celebration.title === "Office of the Dead"
                    ) {
                        liturgicalColor = "#000000"; // black
                    }
                    if (celebration.title.includes("before Advent")) {
                        liturgicalColor = "#4d9c2c"; // green
                    }
                    if (
                        celebration.shortTitle === "Advent III" ||
                        celebration.shortTitle === "Lent IV"
                    ) {
                        liturgicalColor = "#ff91b0"; // rose
                    }
                    if (celebration.title === "Saint John") {
                        liturgicalColor = "#ffffff"; // white
                    }
                    if (celebration.title === "Palm Sunday") {
                        liturgicalColor = "#c23b1d"; // red
                    }
                    if (
                        celebration.collect ===
                        "O God, who by the leading of a star didst manifest thy Only Begotten Son to the Gentiles: mercifully grant that we, who know thee now by faith, may be led onward through this earthly life, until we see the vision of thy heavenly glory; through the same Jesus Christ thy Son our Lord, who liveth and reigneth with thee, in the unity of the Holy Spirit, ever one God, world without end. Amen."
                    ) {
                        liturgicalColor = "#ffffff"; // white
                    }
                    if (celebration.title.includes("Good Friday")) {
                        liturgicalColor = "#000000"; // black
                    }

                    if (celebration.title === "Holy Saturday") {
                        liturgicalColor = "#6f3eb0"; // purple
                    }

                    let isFirstEvensong = false;

                    if (isEvening) {
                        if (
                            celebration.type === "sunday" ||
                            celebration.type === "solemnity" ||
                            celebration.type === "feast"
                        ) {
                            if (
                                firstEvensongList.find(
                                    (ife) => ife === celebration.label
                                )
                            ) {
                                isFirstEvensong = true;
                            }
                        }
                    }

                    const isHighlighted =
                        celebrationIndex === 0 && isToday && !compact;

                    return (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                        >
                            {celebrationIndex > 0 ? (
                                <div
                                    style={{
                                        paddingLeft: 6,
                                        paddingRight: 2,
                                        paddingBottom: 2,
                                        width: 26,
                                        boxSizing: "border-box",
                                    }}
                                >
                                    or:
                                </div>
                            ) : (
                                <></>
                            )}
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    backgroundColor: isHighlighted
                                        ? "#f7f0cb"
                                        : undefined,
                                    boxShadow: isHighlighted
                                        ? "inset 0 0 0 1px rgba(0,0,0,0.05)"
                                        : undefined,
                                    paddingLeft: 6,
                                    paddingRight: 6,
                                    paddingTop: compact ? 2 : 6,
                                    paddingBottom: compact ? 2 : 6,
                                    borderRadius: 4,
                                    flexGrow: 1,
                                }}
                            >
                                <div
                                    style={{
                                        alignSelf: "stretch",
                                        width: 8,
                                        minWidth: 8,
                                        backgroundColor: liturgicalColor,
                                        borderRadius: 2,
                                        boxShadow:
                                            "inset 0 0 0 1px rgba(0,0,0,0.2)",
                                    }}
                                ></div>
                                <div
                                    style={{
                                        paddingLeft: 6,
                                        paddingRight: 6,
                                        flexGrow: 1,
                                    }}
                                >
                                    {isFirstEvensong ? (
                                        <div
                                            style={{
                                                fontSize: "90%",
                                                lineHeight: 1.4,
                                            }}
                                        >
                                            First Evensong of
                                        </div>
                                    ) : (
                                        <></>
                                    )}
                                    <div style={{ lineHeight: 1.35 }}>
                                        {celebration.title}
                                        {celebration.subtitle
                                            ? `, ${celebration.subtitle}`
                                            : ""}
                                        {celebration.type === "feast"
                                            ? " (Feast)"
                                            : ""}
                                        {celebration.type === "solemnity"
                                            ? " (Solemnity)"
                                            : ""}
                                    </div>
                                </div>
                                {compact ? (
                                    <></>
                                ) : (
                                    <Link
                                        to={
                                            celebration.label === "all-souls"
                                                ? `/se/office-of-the-dead/${
                                                      isFirstEvensong
                                                          ? "first-evensong"
                                                          : isEvening
                                                          ? "evensong"
                                                          : "mattins"
                                                  }`
                                                : `/se/${year}/${month}/${date}/${
                                                      celebration.label
                                                  }/${
                                                      isFirstEvensong
                                                          ? "first-evensong"
                                                          : isEvening
                                                          ? "evensong"
                                                          : "mattins"
                                                  }`
                                        }
                                        style={{
                                            color: isHighlighted
                                                ? "white"
                                                : "black",
                                        }}
                                    >
                                        <NewButton
                                            onClick={() => {}}
                                            primary={isHighlighted}
                                        >
                                            <>
                                                Pray{" "}
                                                {isEvening
                                                    ? "Evensong"
                                                    : "Mattins"}
                                            </>
                                        </NewButton>
                                    </Link>
                                )}
                            </div>
                        </div>
                    );
                })}
            {compact ? (
                <></>
            ) : showOther ? (
                <>
                    {[
                        {
                            title: "Office of the Dead",
                            label: "office-of-the-dead",
                            urlOverride: "se/office-of-the-dead",
                            liturgicalColor: "#000000",
                        },
                    ]
                        .concat(
                            props.votivesNotAllowedReason
                                ? []
                                : [
                                      {
                                          title: "Votive Office of Saint Peter and Saint Paul",
                                          label: "votive-of-saints-peter-and-paul",
                                          urlOverride: null,
                                          liturgicalColor: "#c23b1d",
                                      },
                                      {
                                          title: "Votive Office of Our Lord Jesus Christ, Supreme and Eternal High Priest",
                                          label: "votive-of-oljc-high-priest",
                                          urlOverride: null,
                                          liturgicalColor: "#FFFFFF",
                                      },
                                  ]
                        )
                        .map((otherRow) => {
                            return (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                    }}
                                >
                                    <div
                                        style={{
                                            paddingLeft: 6,
                                            paddingRight: 2,
                                            paddingBottom: 2,
                                            width: 26,
                                            boxSizing: "border-box",
                                        }}
                                    >
                                        or:
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            paddingLeft: 6,
                                            paddingRight: 6,
                                            paddingTop: compact ? 2 : 6,
                                            paddingBottom: compact ? 2 : 6,
                                            borderRadius: 4,
                                            flexGrow: 1,
                                        }}
                                    >
                                        <div
                                            style={{
                                                alignSelf: "stretch",
                                                width: 8,
                                                minWidth: 8,
                                                backgroundColor:
                                                    otherRow.liturgicalColor,
                                                borderRadius: 2,
                                                boxShadow:
                                                    "inset 0 0 0 1px rgba(0,0,0,0.2)",
                                            }}
                                        ></div>
                                        <div
                                            style={{
                                                paddingLeft: 6,
                                                paddingRight: 6,
                                                flexGrow: 1,
                                            }}
                                        >
                                            <div style={{ lineHeight: 1.35 }}>
                                                {otherRow.title}
                                            </div>
                                        </div>
                                        {compact ? (
                                            <></>
                                        ) : (
                                            <Link
                                                to={
                                                    otherRow.urlOverride
                                                        ? `/${
                                                              otherRow.urlOverride
                                                          }/${
                                                              isEvening
                                                                  ? "evensong"
                                                                  : "mattins"
                                                          }`
                                                        : `/${PRAY_PATH}/${year}/${month}/${date}/${
                                                              otherRow.label
                                                          }/${
                                                              isEvening
                                                                  ? "evensong"
                                                                  : "mattins"
                                                          }`
                                                }
                                                style={{
                                                    color: "black",
                                                }}
                                            >
                                                <NewButton onClick={() => {}}>
                                                    <>
                                                        Pray{" "}
                                                        {isEvening
                                                            ? "Evensong"
                                                            : "Mattins"}
                                                    </>
                                                </NewButton>
                                            </Link>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    {props.votivesNotAllowedReason ? (
                        <div style={{ color: RUBRIC_COLOR, paddingLeft: 32 }}>
                            Votive Offices are not said{" "}
                            {props.votivesNotAllowedReason}.
                        </div>
                    ) : (
                        <></>
                    )}
                </>
            ) : (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        height: 40,
                    }}
                >
                    <div
                        style={{
                            paddingLeft: 6,
                            paddingRight: 8,
                            paddingBottom: 4,
                        }}
                    >
                        or:
                    </div>
                    <NewButton
                        onClick={() => {
                            setShowOther(true);
                        }}
                    >
                        Other...
                    </NewButton>
                </div>
            )}
            {!compact &&
            outranked.filter((c) => !c.label.includes("votive-")).length > 0 ? (
                <div
                    style={{
                        paddingTop: 16,
                        lineHeight: 1.4,
                        fontSize: "90%",
                        paddingLeft: 6,
                    }}
                >
                    <div style={{}}>Outranked:</div>
                    {outranked
                        .filter((c) => !c.label.includes("votive-"))
                        .map((celebration) => {
                            let isFirstEvensong = false;

                            if (isEvening) {
                                if (
                                    celebration.type === "sunday" ||
                                    celebration.type === "solemnity" ||
                                    celebration.type === "feast"
                                ) {
                                    if (
                                        firstEvensongList.find(
                                            (ife) => ife === celebration.label
                                        )
                                    ) {
                                        isFirstEvensong = true;
                                    }
                                }
                            }

                            return (
                                <div>
                                    <Link
                                        to={`/se/${year}/${month}/${date}/${
                                            celebration.label
                                        }/${
                                            isFirstEvensong
                                                ? "first-evensong"
                                                : isEvening
                                                ? "evensong"
                                                : "mattins"
                                        }`}
                                        style={{
                                            color: "#777",
                                            textDecoration: "underline",
                                        }}
                                    >
                                        {isFirstEvensong
                                            ? "First Evensong of "
                                            : ""}
                                        {celebration.title}
                                        {celebration.subtitle
                                            ? `, ${celebration.subtitle}`
                                            : ""}
                                        {celebration.type === "feast"
                                            ? " (Feast)"
                                            : ""}
                                        {celebration.type === "solemnity"
                                            ? " (Solemnity)"
                                            : ""}
                                    </Link>
                                </div>
                            );
                        })}
                </div>
            ) : (
                <></>
            )}
        </div>
    );
};
